import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const financialAccountsFilterQueryAtom = createQueryAtomFactory(
  'finance.financialAccountsFilter',
  (params: { searchTerm?: string; limit?: number }) => ({
    financialAccounts: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          visibleInPayments: true,
        },
        pagination: {
          offset: 0,
          limit: params.limit ?? 20,
        },
        sorting: ['NameAsc'],
      },
      entries: {
        id: true,
        name: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data) => ({
      accounts:
        data?.financialAccounts.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
        })) ?? [],
    }),
  },
);
